export default __webpack_public_path__ + "static/media/SigitaLovelace.c47d0e69.png";